module.exports = __webpack_public_path__ + "files/730577a64547f11816b1af46e3bf0b1d.png";